import gql from 'graphql-tag'

export const serviceHistoryUserNoteCreate = gql`
  mutation serviceHistoryUserNoteCreate($text: NonEmptyString!, $deviceId: ID!) {
    serviceHistoryUserNoteCreate(input: { text: $text, deviceId: $deviceId }) {
      success
    }
  }
`
